module.exports = {"id":"214986","name":"Fernando Meza","rating":"71","photo":"./data/images/photos/0/214986.png","club":{"name":"Colo-Colo","logo":"./data/images/clubs/Colo-Colo.png"},"positions":["DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FernandoMeza0.json
// module id = 1419
// module chunks = 0